import PropTypes from 'prop-types'

export const FieldType = {
  label: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  readonly: PropTypes.bool,
  disabled: PropTypes.bool,
}
